import { render, staticRenderFns } from "./selfAccountEdit.vue?vue&type=template&id=50fb3681&scoped=true&"
import script from "./selfAccountEdit.vue?vue&type=script&lang=js&"
export * from "./selfAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb3681",
  null
  
)

export default component.exports